const d3 = require('d3')
const { collapse, wrapText, helpers } = require('../utils')
const defineBoxShadow = require('../defs/box-shadow')
const defineAvatarClip = require('../defs/avatar-clip')
const render = require('./render')
const renderUpdate = require('./render-update')
const defaultConfig = require('./config')

module.exports = {
  init,
  searchEmployee
}

let initialOptions = null

function init (options) {
  if (initialOptions === null) {
    initialOptions = options
  }
  // Merge options with the default config
  window.config = {
    ...defaultConfig,
    ...options,
    treeData: options.data
  }

  // console.log(options.data)

  if (!config.id) {
    console.error('react-org-chart: missing id for svg root')
    return
  }

  const {
    id,
    treeData,
    lineType,
    margin,
    nodeWidth,
    nodeHeight,
    nodeSpacing,
    shouldResize
  } = config

  // Calculate how many pixel nodes to be spaced based on the
  // type of line that needs to be rendered
  if (lineType === 'angle') {
    config.lineDepthY = nodeHeight + 40
  } else {
    config.lineDepthY = nodeHeight + 60
  }

  // Get the root element
  const elem = document.querySelector(id)

  if (!elem) {
    console.error(`react-org-chart: svg root DOM node not found (id: ${id})`)
    return
  }

  // Reset in case there's any existing DOM
  elem.innerHTML = ''
  
  const elemWidth = elem.offsetWidth
  // const elemHeight = elem.offsetHeight
  const elemHeight = document.getElementById('root').parentElement.parentElement.parentElement.offsetHeight
  // console.log(document.getElementById('root').parentElement.parentElement.parentElement.parentElement.parentElement.offsetHeight)

  // Setup the d3 tree layout
  config.tree = d3.layout
    .tree()
    .nodeSize([nodeWidth + nodeSpacing, nodeHeight + nodeSpacing])

  // Calculate width of a node with expanded children
  
  const childrenWidth = parseInt(treeData.children.length * nodeWidth / 2)

  // Add svg root for d3
  
  const svgroot = d3
    .select(id)
    .append('svg')
    .attr('width', elemWidth)
    .attr('height', elemHeight)

  // Add our base svg group to transform when a user zooms/pans
  window.svg = svgroot
    .append('g')
    .attr(
      'transform',
      'translate(' +
        parseInt(
          childrenWidth + (elemWidth - childrenWidth * 2) / 2 - margin.left / 2
        ) +
        ',' +
        20 +
        ')'
    )

  // Define box shadow and avatar border radius
  defineBoxShadow(svgroot, 'boxShadow')
  defineAvatarClip(svgroot, 'avatarClip', {
    borderRadius: 40
  })

  // Center the viewport on initial load
  treeData.x0 = 0
  treeData.y0 = elemHeight / 2

  // Collapse all of the children on initial load
  treeData.children.forEach(collapse)
    
  // Connect core variables to config so that they can be
  // used in internal rendering functions
  config.svg = svg
  config.svgroot = svgroot
  config.render = render

  // Defined zoom behavior
  window.zoom = d3.behavior
    .zoom()
    // Define the [zoomOutBound, zoomInBound]
    // .scaleExtent([0.4, 2])
    .duration(50)
    .on('zoom', renderUpdate(config))

  // Attach zoom behavior to the svg root
  svgroot.call(zoom)

  // Define the point of origin for zoom transformations
  zoom.translate([
    parseInt(
      childrenWidth + (elemWidth - childrenWidth * 2) / 2 - margin.left / 2
    ),
    20
  ])

  // Add listener for when the browser or parent node resizes
  const resize = () => {
    if (!elem) {
      global.removeEventListener('resize', resize)
      return
    }

    svgroot.attr('width', elem.offsetWidth).attr('height', elem.offsetHeight)
  }

  if (shouldResize) {
    global.addEventListener('resize', resize)
  }

  // Start initial render
  render(config)

  // Update DOM root height
  d3.select(id).style('height', elemHeight + margin.top + margin.bottom)
}

function searchEmployee (employee_uid) {
  // console.log(d3.selectAll('.org-chart-node'));

  let found = false
  d3.selectAll('.org-chart-node').each(function (node) { // search at opened nodes
    if (node.employee_uid === employee_uid) {
      found = true
      if (node._children) {
        node.children = node._children
        node._children = null
      }

      render({
        ...window.config,
        sourceNode: node
      })
      
      let v = document.getElementById('root').parentElement.parentElement.parentElement // get div element  
      svg.transition()
        .duration(750)
        .call(zoom.translate([(v.offsetWidth / 2) - node.x - 200, (v.offsetHeight / 2) - node.y - 200]).scale(0.9).event)
        .each('end', () => {
          ripple(node)
        }) 
    }
  })
  
  // let searchedNode = null  

  if (found !== true) {
    init(initialOptions)

    let expandDone = false

    d3.selectAll('.org-chart-node').each(function (node) { // drill down each available node
      if (node._children != null && node.depth > 0 && expandDone === false) {
        // console.log(node.person.name);

        let currentDrill = null

        if (expandAll({
          person: node.person,
          children: node.children ? node.children.map(a => Object.assign({}, a)) : null,
          _children: node._children ? node._children.map(a => Object.assign({}, a)) : null
        }, employee_uid, []) == true) {
          correctList.forEach((index, loopIndex) => {
            if (loopIndex === 0) {
              if (node._children) {
                node.children = node._children
                node._children = null
                currentDrill = node.children[index]
              }
            } else {
              if (currentDrill._children) {
                currentDrill.children = currentDrill._children
                currentDrill._children = null

                currentDrill.children.forEach((child) => { // close all children
                  // console.log('closing');
                  if (child.children) {
                    child._children = child.children
                    child.children = null
                  }
                })
              }    
              
              currentDrill = currentDrill.children[index]
            }

            if (loopIndex === correctList.length - 1) {
              // console.log('this node');
              // console.log(currentDrill);             
              
              if (currentDrill._children) {
                console.log('opening ' + currentDrill.person.name)
                currentDrill.children = currentDrill._children
                currentDrill._children = null
              }
              
              render({
                ...window.config,
                sourceNode: node
              })

              let v = document.getElementById('root').parentElement.parentElement.parentElement // get div element  
              svg.transition()
                .duration(750)
                .call(zoom.translate([(v.offsetWidth / 2) - currentDrill.x - 200, (v.offsetHeight / 2) - currentDrill.y - 200]).scale(0.9).event)
                .each('end', () => {
                  ripple(currentDrill)
                })
              correctList = []
              expandDone = true // flag to not run if already found
            }
          })
        } else {
          console.log('not found')
        }
      }
    })
  }
}

var correctList = []

function expandAll (node, employee_uid, arr) {
  // console.log(node.person.name);
  
  node.children = node._children ? node._children.map(a => Object.assign({}, a)) : null
  // node._children = null
  
  if (node.employee_uid === employee_uid) {
    correctList = []
    correctList = arr
    
    return true
  }

  if (node.children != null) {
    for (let x = 0; x < node.children.length; x++) {
      arr.push(x)
        
      if (expandAll(node.children[x], employee_uid, arr) === true) {
        return true
      } else {
        arr.pop()
      }
    }
  }
  
  return false
}

function ripple (node) {
  for (var i = 1; i < 5; ++i) {
    var circle = svg.append('circle')
      .attr('cx', node.x + 120)
      .attr('cy', node.y + 60)
      .attr('r', 0)
      .style('stroke-width', 5 / (i))
      .transition()
      .delay(Math.pow(i, 2.5) * 50)
      .duration(1000)
      .ease('quad-in')
      .attr('r', 50)
      .style('stroke-opacity', 0)
      .each('end', function () {
        d3.select(this).remove()
      })
  }
}
